import {Component, OnInit} from '@angular/core';
import {MercadoInternoVariedadesService} from "./mercado-interno-variedades.service";
import {MercadoInternoMercadoriasService} from "./mercado-interno-mercadorias.service";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";

declare let swal, $: any;

@Component({
  selector: 'app-mercado-interno-variedades',
  templateUrl: './mercado-interno-variedades.component.html'
})
export class MercadoInternoVariedadesComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"nome":"", "mercadoria":""};

  variedades: any[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listMercadorias = [];

  constructor(
    formBuilder: FormBuilder,
    private mercadoriasVariedadesService: MercadoInternoVariedadesService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl == 'mercado-interno-mercadorias' || acaoUrl == 'prestacao-mapa' || acaoUrl == 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      nome: [],
      mercadoria: []
    });

    this.mercadoriasService.get(null, null, ['id', 'nome_pt'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(mercadoria) {
    let variedades = this.variedades;
    let mercadoriasVariedadesService = this.mercadoriasVariedadesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarMercadoria')+mercadoria.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        let index = variedades.indexOf(mercadoria);
        variedades.splice(index, 1);

        mercadoriasVariedadesService.apagar(mercadoria.id)
          .subscribe(res => {
              self.variedades = variedades;
            },
            err => {
              variedades.splice(index, 0, mercadoria);
              self.variedades = variedades;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.nome != ''){
      filtros['nome'] = '**:'+this.filtroPesquisa.nome;
    }

    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }

    this.mercadoriasVariedadesService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria'], filtros)
      .subscribe(
        json => {
          this.variedades = json.Payload;
          this.totalItens = json.Records;
          this.carregandoTabela = false;
        },
        error => {
          this.carregandoTabela = false;
          this.func.showErro(error.json());
        });
  }

  resetFiltros(){
    this.filtroPesquisa = {"nome":"", "mercadoria":""};
    this.formPesquisaAvancada.reset();
    this.getPage(1);
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('hide');
    this.getPage(1);
  }

  limpaPesquisaAvancada() {
    this.resetFiltros();
    $('#modalPesquisaAvancada').modal('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-variedades.component.ts